import React, { Fragment } from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import ScheduleField from "components/ScheduleField";
import BillingPeriodField from "components/BillingPeriodField";
import AmountField from "components/AmountField";
import FieldController from "components/FieldController";
import FormFactory from "components/FormFactory";
import { getFieldPath } from "utils/form";
import { SCHEDULE_TYPE } from "utils/constants/price";
import { useScrollToElement } from "utils/hooks/editor";

const PaymentBlock = (props) => {
  const { values } = useFormikContext();
  useScrollToElement(props.name);
  const rootPath = `${props.name}.data`;

  const formattedPricePath = getFieldPath(rootPath, `amount.formattedPrice`);
  const currencyPath = getFieldPath(rootPath, `amount.currency`);

  const recurringPath = getFieldPath(rootPath, `amount.recurring`);
  const recurringIntervalPath = getFieldPath(
    rootPath,
    `amount.recurring.interval`
  );
  const recurringIntervalCountPath = getFieldPath(
    rootPath,
    `amount.recurring.interval_count`
  );

  const formattedPrice = get(values, formattedPricePath);
  const currency = get(values, currencyPath);
  const recurringInterval = get(values, recurringIntervalPath);

  const scheduleValue = isEmpty(recurringInterval)
    ? SCHEDULE_TYPE.ONE_TIME
    : SCHEDULE_TYPE.RECURRING;

  let fields = [
    <AmountField
      hideLabel
      key={currency}
      value={formattedPrice}
      name={formattedPricePath}
      currency={currency}
      currencyPath={currencyPath}
      recurringIntervalPath={recurringIntervalPath}
      recurringInterval={recurringInterval}
      noBlocksStyle
    />
  ];

  fields.push(
    <ScheduleField
      label="Billing"
      noBlocksStyle
      name={recurringPath}
      value={scheduleValue}
    />
  );

  if (!isEmpty(recurringInterval)) {
    fields.push(
      <BillingPeriodField
        label="Every"
        intervalName={recurringIntervalPath}
        intervalCountName={recurringIntervalCountPath}
        value={recurringInterval}
        noBlocksStyle
      />
    );
  }

  /**
   * This isnt right
   * Should just present a single action
   */
  const schema = {
    ...props.schema,
    properties: {
      actions: props.schema.properties.actions
    }
  };

  return (
    <Fragment>
      <div className="bg-white h-100 bh--inset">
        <div className="ph3 pt3">
          <FieldController
            name="title"
            label="Title"
            key={`${rootPath}.title`}
            rootPath={rootPath}
            fieldKey="title"
          />
        </div>
        <div className="ph3 pt3">
          <FieldController
            name="subtitle"
            label="Subtitle"
            key={`${rootPath}.subtitle`}
            rootPath={rootPath}
            fieldKey="subtitle"
          />
        </div>
        <div className="ph3 pt3">
          <label className="f6 mb2 dib fw6">Amount</label>
          {fields.map((node, nodeIx) => (
            <div key={nodeIx} className={nodeIx ? "pt3" : ""}>
              {node}
            </div>
          ))}
        </div>
        <FormFactory schema={schema} name={props.name} uid={props.uid} />;
      </div>
    </Fragment>
  );
};

PaymentBlock.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};

export default PaymentBlock;
